import * as turf from '@turf/turf';

/**
 * Returns a GeoJSON Polygon feature representing a rectangle centered at (lng, lat)
 * with the given width and height in kilometers, aligned to lat/lon axes.
 */
export default function getAccurateRectangle(lng, lat, widthKm, heightKm) {

  // Convert center to a Turf point
  const center = turf.point([lng, lat]);

  // Half-distances in kilometers
  const halfWidth = widthKm / 2.0;
  const halfHeight = heightKm / 2.0;

  // Move center west/east by halfWidth
  const westPoint = turf.destination(center, halfWidth, -90, {units: 'kilometers'}); // bearing -90 = west
  const eastPoint = turf.destination(center, halfWidth, 90, {units: 'kilometers'});  // bearing 90 = east

  // From the west/east points, move north or south by halfHeight
  // topLeft  (west + north)
  const topLeft = turf.destination(westPoint, halfHeight, 0, {units: 'kilometers'});
  // topRight (east + north)
  const topRight = turf.destination(eastPoint, halfHeight, 0, {units: 'kilometers'});
  // bottomLeft  (west + south)
  const bottomLeft = turf.destination(westPoint, halfHeight, 180, {units: 'kilometers'});
  // bottomRight (east + south)
  const bottomRight = turf.destination(eastPoint, halfHeight, 180, {units: 'kilometers'});

  // Build a Polygon feature for the rectangle
  const rectangle = turf.polygon([[
    turf.getCoord(bottomLeft),
    turf.getCoord(bottomRight),
    turf.getCoord(topRight),
    turf.getCoord(topLeft),
    turf.getCoord(bottomLeft) // close the polygon
  ]]);

  return rectangle;
}
